/**
 * Created by PhpStorm on 08.05.2017.
 * Author: Shabalin Pavel
 * Email: aisamiery@gmail.com
 */
'use strict';

angular.module('far.models.subclub', [])
    .service('Subclub', function ($log, $http) {

        this.new = function (data) {
            return new Subclub(data);
        };

        this.get = function (routeId, callback) {
            var route = new Subclub({});

            $http.get(Routing.generate('api_get_subclub', {club: routeId}))
                .then(function (response) {
                    route.update(response.data);

                    if (typeof callback == 'function') {
                        callback(route);
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });

            return route;
        };

        // Модель логики, содержит бизнес логику
        function Subclub(data) {
            angular.merge(this, data);

            Object.defineProperty(this, 'update', {
                enumerable: false,
                get: function () {
                    return function (data) {
                        angular.merge(this, data);

                        return this;
                    }
                }
            });

            Object.defineProperty(this, 'save', {
                enumerable: false,
                get: function () {
                    return function () {
                        var method = this.id ? 'put' : 'post',
                            url = this.id ?
                                Routing.generate('api_put_subclub', {subclub: this.id}) :
                                Routing.generate('api_post_subclub');

                        var data = angular.merge({}, this);

                        if ( angular.isObject( data.country ) ) {
                            data.country = data.country.name;
                        }

                        if ( angular.isObject( data.region ) ) {
                            data.region = data.region.name;
                        }

                        if ( angular.isObject( data.city ) ) {
                            data.city = data.city.name;
                        }

                        if ( angular.isObject( data.user ) ) {
                            data.user = data.user.id;
                        }

                        if ( angular.isObject( data.avatar ) ) {
                            data.avatar = data.avatar.id;
                        }

                        if ( angular.isObject( data.club ) ) {
                            data.parent = data.club.id;
                        }

                        return $http[method](url, data);
                    }
                }
            });
        }
    });